import classNames from 'classnames';
import React from 'react';
import { IconProps } from '../types/icon';
import styles from './icon.module.sass';

export function IconTikTok({ className }: IconProps) {
  return (
    <svg
      className={classNames(styles.icon, className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <title>TikTok</title>
      <path
        d="M15.7507 3H12.732V15.2609C12.732 16.7218 11.571 17.9217 10.1261 17.9217C8.68123 17.9217 7.52018 16.7218 7.52018 15.2609C7.52018 13.8261 8.65543 12.6521 10.0487 12.6V9.52175C6.97836 9.5739 4.50146 12.1043 4.50146 15.2609C4.50146 18.4435 7.02996 21 10.1519 21C13.2738 21 15.8023 18.4174 15.8023 15.2609V8.9739C16.9376 9.8087 18.3308 10.3043 19.8015 10.3304V7.25218C17.531 7.17391 15.7507 5.29565 15.7507 3Z"
        fill="black"
      />
    </svg>
  );
}
